import {Route, Switch} from 'react-router-dom';
import ProductList from '../features/products/ProductList';
import Support from './customer/Support';
import Cart from '../features/cart/Cart';
import Checkout from '../features/cart/Checkout';
import {H1} from './ui/Header';
import React from 'react';
import ProductDetail from '../features/products/ProductDetail';
import Login from './Login';
import UserSignOut from '../features/user/UserSignOut';
import Account from './Account';
import Orders from './Orders';

export default function Router() {
  return (
    <>
      <Switch>
        <Route exact path='/'>
          <ProductList/>
        </Route>

        <Route path='/product/:sku'>
          <ProductDetail/>
        </Route>

        <Route path='/support'>
          <Support/>
        </Route>

        <Route path='/cart'>
          <Cart/>
        </Route>

        <Route path='/checkout'>
          <Checkout/>
        </Route>

        <Route path='/signin'>
          <Login redirect='/'/>
        </Route>

        <Route path='/signout'>
          <UserSignOut/>
        </Route>

        <Route path='/profile'>
          <Account/>
        </Route>

        <Route path='/orders'>
          <Orders/>
        </Route>

        <Route path='*'>
            <H1 color='textOnDark'>Error: 404<br/>Page not found!</H1>
        </Route>
      </Switch>
    </>
  )
}